/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import React, { useRef, useCallback, useState, useMemo } from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { format } from 'date-fns';
import Select from '../../../../components/Select';
import DatePicker from '../../../../components/DatePicker';
import Modal from '../../../../components/Modal';
import Button from '../../../../components/Button';
import { ArrayFilters } from '../../../../interfaces/ticket';
import { Container } from './styles';

interface FiltersModalProps {
  show: boolean;
  title: string;
  filters: ArrayFilters;
  handleClose(): void;
  handleApplyFilter(filters: any): void;
}

const FiltersModal: React.FC<FiltersModalProps> = ({
  handleClose,
  handleApplyFilter,
  filters,
  show,
  title,
}) => {
  const formTableRef = useRef<FormHandles>(null);

  const [defaultStart, setDefaultStart] = useState<string>(() => {
    const start = localStorage.getItem('@TransfacilPJ:cardOrderStartDate');
    if (start) return start;
    return '';
  });

  const [defaultEnd, setDefaultEnd] = useState<string>(() => {
    const end = localStorage.getItem('@TransfacilPJ:cardOrderEndDate');
    if (end) return end;
    return '';
  });

  const filtersObject = useMemo(() => {
    const newObj = filters.filters.reduce(
      (key, name) => Object.assign(key, name),
      {},
    );

    return newObj;
  }, [filters]);

  const statusOptions = [
    { value: '', label: 'Todos' },
    { value: 'E', label: 'Em Andamento' },
    { value: 'C', label: 'Pronto para retirada na Central' },
    { value: 'F', label: 'Finalizado' },
  ];

  const handleSubmit = useCallback((data: any) => {
    const formatedData = {
      ...data,
      end_date: data.end_date ? format(data.end_date, 'dd/MM/yyyy') : '',
      start_date: data.start_date ? format(data.start_date, 'dd/MM/yyyy') : '',
    };

    handleApplyFilter(formatedData);
    localStorage.setItem(
      '@TransfacilPJ:cardOrderStartDate',
      formatedData.start_date,
    );
    localStorage.setItem(
      '@TransfacilPJ:cardOrderEndDate',
      formatedData.end_date,
    );
  }, []);

  return (
    <Container>
      <Modal show={show} title={title} handleClose={handleClose}>
        <Form ref={formTableRef} onSubmit={handleSubmit}>
          <p style={{ marginBottom: '10px', marginTop: '0' }}>Periodo</p>

          <DatePicker
            name="start_date"
            label="De"
            placeholder="Digite a data"
            value={defaultStart}
            onSelect={value => setDefaultStart(format(value, 'dd/MM/yyyy'))}
          />

          <DatePicker
            name="end_date"
            label="Até"
            placeholder="Digite a data"
            value={defaultEnd}
            onSelect={value => setDefaultEnd(format(value, 'dd/MM/yyyy'))}
          />

          <Select
            name="status"
            label="Status"
            placeholder="Selecione o status"
            defaultValue={
              filtersObject?.status === 'E'
                ? {
                    value: filtersObject?.status,
                    label: 'Em Andamento',
                  }
                : filtersObject?.status === 'C'
                ? {
                    value: filtersObject?.status,
                    label: 'Pronto para retirada na Central',
                  }
                : filtersObject?.status === 'F'
                ? {
                    value: filtersObject?.status,
                    label: 'Finalizado',
                  }
                : null
            }
            options={statusOptions}
          />
          <div className="buttonsContainer">
            <Button color="orange" padding="1" type="submit">
              Aplicar Filtros
            </Button>
          </div>
        </Form>
      </Modal>
    </Container>
  );
};

export default FiltersModal;
